import { Controller } from "stimulus"

// Initializes bootstrap-switch on Turbo visits.
// Use on a checkbox: data: { controller: 'bs-switch', size: 'mini', 'on-text': 'YES', 'off-text': 'NO' }
// Or on a parent: data: { controller: 'bs-switch' } (finds input.bs-switch descendants)
export default class extends Controller {
  connect() {
    this.switches().each((_, el) => $(el).bootstrapSwitch())
  }

  disconnect() {
    this.switches().each((_, el) => {
      const $el = $(el)
      if ($el.data("bootstrap-switch")) {
        $el.bootstrapSwitch("destroy")
      }
    })
  }

  switches() {
    if (this.element.matches("input.bs-switch")) {
      return $(this.element)
    }

    return $(this.element).find("input.bs-switch:checkbox")
  }
}
